import type {SphereFeatureCardValue} from '@/stores/apolloPlatform/cores/portalNavigation';

const STATUS = {
  planned: {label: 'Planned', class: 'text-bg-secondary'},
  in_progress: {label: 'In progress', class: 'text-bg-primary'},
  released: {label: 'Released', class: 'text-bg-success'},
} as const;

/** Bootstrap badge for a feature card's status, or `null` when it has none. */
export const getStatusBadge = (
  status: SphereFeatureCardValue['status'],
  translate: (key: string) => string,
) => {
  const s = STATUS[status as keyof typeof STATUS];
  return s ? {label: translate(s.label), class: s.class} : null;
};

/** The button needs a label and somewhere to go. */
export const hasLink = (value: SphereFeatureCardValue) =>
  !!value.link_label && !!(value.external_url || value.internal_page_url);
